import { useEffect, useState } from "react";
import { H2, Body } from "@leafygreen-ui/typography";
import { RadioGroup, Radio } from "@leafygreen-ui/radio-group";
import Button from "@leafygreen-ui/button";
import Banner from "@leafygreen-ui/banner";
import { css } from "@leafygreen-ui/emotion";

import { useApi } from "../providers/Api";

const pageStyle = css`
  max-width: 600px;
`;

const sectionStyle = css`
  margin: 24px 0;
`;

const warningStyle = css`
  margin: 16px 0;
`;

export default function AdminSettings() {
  const api = useApi();
  const [enableTIBypass, setEnableTIBypass] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const settings = await api.getAppSettings();
      setEnableTIBypass(settings.enableTIBypass === true);
      setLoading(false);
    };
    load();
  }, []);

  const handleSave = async () => {
    await api.updateAppSettings({ enableTIBypass });
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  if (loading) return null;

  return (
    <div className={pageStyle}>
      <H2>Admin Settings</H2>
      <div className={sectionStyle}>
        <Body weight="medium">Enable TI Bypass</Body>
        <Body>
          If TI is down, enable the bypass to let skill checks run. This is a
          temporary solution and will be applied to all short links. If unsure,
          do NOT enable.
        </Body>
        <div className={warningStyle}>
          <Banner variant="warning">
            Enabling TI bypass affects all short links. Only use if TI is confirmed down.
          </Banner>
        </div>
        <RadioGroup
          value={String(enableTIBypass)}
          onChange={(e) => setEnableTIBypass(e.target.value === "true")}
        >
          <Radio value="false">Disabled</Radio>
          <Radio value="true">Enabled</Radio>
        </RadioGroup>
      </div>
      <Button variant="primary" onClick={handleSave}>Save</Button>
      {saved && <Body>&nbsp; Settings saved.</Body>}
    </div>
  );
}
